
export default function WhatsAppButton() {
  const phoneNumber = "+966501234567";
  const message = "مرحباً، أود الاستفسار عن خدماتكم في الإنتاج الإعلامي";
  
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 left-6 z-50 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110"
      title="تواصل معنا عبر واتساب"
    >
      <div className="w-6 h-6 flex items-center justify-center">
        <i className="ri-whatsapp-fill text-2xl"></i>
      </div>
    </a>
  );
}
